module.exports = __webpack_public_path__ + "img/growcify-app-banner-2.5320a099.png";